import { Component } from '@angular/core';
import { AutomaticSerialCreationComponent } from '../automatic-serial-creation/automatic-serial-creation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-serial',
  templateUrl: './add-serial.component.html',
  styleUrls: ['./add-serial.component.css']
})
export class AddSerialComponent {
  displayedColumns: string[] = ['s_no', 'mfr_serial_no', 'serial_no', 'lot_no', 
  'admission_date', 'mfg_date', 'expiration_date', 'mfr_warranty_start', 'mfr_warranty_end'];
 dataSource : any = [{
  
  }];

  constructor(public dialog: MatDialog,) {

  }

openDialog(): void {
  this.dialog.open(AutomaticSerialCreationComponent, {
}); 
}

}
